<app-mobile-header *ngIf="isMobile"></app-mobile-header>
<router-outlet></router-outlet>
<app-scroll-to-top-button></app-scroll-to-top-button>
